import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from 'semantic-ui-react';
import { Field } from 'redux-form';
import './styles.less';
import { FormTextAreaField } from '../../../../../semantic-ui/components/form-textarea-field';
import { CustomLoader } from '../../../../../components/custom-loader';

export const NoteFormView = ({ isLoading }) => {
	if (isLoading) {
		return <CustomLoader />;
	}

	return (
		<>
			<div className="note-form">
				<Grid className="note-form__content">
					<Grid.Row className="note-form__content-row">
						<Grid.Column width={15} className="note-form__content-column">
							Заметка
							<div className="note-form__content-column-field">
								<Field
									name="note"
									type="text"
									component={FormTextAreaField}
									autoComplete="off"
									width="100%"
									height="100%"
									resize="vertical"
									rows={6}
									placeholder="Добавьте заметку при необходимости"
								/>
							</div>
						</Grid.Column>
					</Grid.Row>
				</Grid>
			</div>
		</>
	);
};

NoteFormView.propTypes = {
	isLoading: PropTypes.bool.isRequired,
};
